import Settings from './views/Settings.vue';
import Overview from './views/Overview.vue';

export default [
  {
    path: 'settings',
    component: Settings,
    name: '规则配置',
  },
  {
    path: 'overview',
    component: Overview,
    name: '数据总览',
  },
];
